export const experimentsConfig = {
    design_services_sdp_product_modeling_poc: {
        variations: ['control', 'test'],
    } as const,
    ds_sdp_ibpo: {
        variations: ['control', 'test'],
    } as const,
    design_services_hub_page_recently_viewed_rec: {
        variations: ['control', 'test'],
    } as const,
} as const;
